(function() {
  
  /**
   * @ngdoc factory
   * @name RcOffer
   * @description Model for an individual Offer
   */
  angular.module('rcCommerce.offer', []).factory('RcOffer', function(_) {
    /**
     * @description Creates a new RcOffer for use.
     *
     * @param {Object} options Initialization Object (params described below)
     * @param {String} options.offer_id An Offer's ID
     * @param {String} options.offer_type the type of offer; BASE
     * @param {String} options.price_point the price point of the offer; REGULAR
     * @param {String} options.commitment the commitment; MONTH, YEAR
     * @param {String} options.term the term; MONTHLY
     * @param {String} options.product_code the SAP code for the product
     * @param {String} options.product_arrangement_code the product arrangement code
     * @param {String} options.customer_segment the customer segment; TEAM, ENTERPRISE
     * @param {String} options.sales_channel the sales channel; DIRECT, INDIRECT
     * @param {String} options.language the language of the offer; MULT
     * @param {Array} options.platforms the platforms supported by the primary product
     * @param {String} options.platform duplicative of platforms
     * @param {String} options.merchant the seller; ADOBE
     * @param {String} options.buying_program the buying program; RETAIL, VIP, ETLA
     * @param {Array} options.customer_ui the set of channels this offer should be shown in
     * @param {Array} options.materials an array of material objects containing country, material_id,
     *      and renewal_material_id. Only returned for RETAIL and VIP offers.
     * @param {String} options.compliance.terms_href the URL to compliance terms for this offer.
     *      Only returned for RETAIL.
     * @param {Object} options.product_arrangement the product arrangement of this offer
     * @param {String} options.product_arrangement.code the product arrangement code
     * @param {String} options.product_arrangement.label the product arrangement label
     * @param {String} options.product_arrangement.family the product arrangement family
     * @param {String} options.product_arrangement.cloud the product arrangement cloud; CREATIVE,
     *      DOCUMENT, EXPERIENCE, OTHER, UNKNOWN.
     * @param {String} options.product_arrangement.overdeployment_allowed whether this product can be
     *      over-deployed. Generally, true for ETLA, and false for others.
     * @param {String} options.product_arrangement.fulfillable_items an array of fulfillable items, containing
     *      id, code, label, type, fulfillment_configurable, delegation_configurable, delegation_type,
     *      charging_model.cap, charging_model.model, charging_model.unit, overdeployment_allowed.
     * @param {Object} options.pricing pricing information for this offer. Only present for RETAIL.
     * @param {Object} options.pricing.currency the currency of the offer.
     * @param {String} options.pricing.currency.format_string the string to use when displaying the price.
     * @param {String} options.pricing.currency.code the code of the currency, ie USD
     * @param {String} options.pricing.currency.use_precision whether to use double values (ie, 10.99 vs 10)
     * @param {String} options.pricing.currency.symbol the symbol of the currency, ie US $
     * @param {String} options.pricing.currency.delimiter the separator to use, generally . or ,
     * @param {Array} options.pricing.prices an array of price details for this offer
     * @param {String} options.pricing.prices.sku the SKU backing this offer
     * @param {Object} options.pricing.prices.price_details the price details for this offer
     * @param {String} options.pricing.prices.price_details.display_rules.price the price of this offer
     * @param {String} options.pricing.prices.price_details.display_rules.tax included or excluded
     * @param {String} options.pricing.prices.price_details.unit.amount_without_tax the price of this offer without tax
     * @param {String} options.pricing.prices.price_details.unit.tax the amount of tax being charged
     * @param {String} options.pricing.prices.price_details.unit.tax_rate the percentage tax rate being applied
     * @param {String} options.pricing.prices.price_details.unit.includes_discount whether a discount is being applied
     * @param {String} options.pricing.prices.price_details.annual_cost.amount_without_tax the amount paid in a year, without tax
     * @param {String} options.pricing.prices.price_details.annual_cost.tax the amount paid in tax in a year
     * @param {String} options.pricing.prices.price_details.annual_cost.tax_rate the percentage tax rate being applied
     * @param {String} options.pricing.prices.price_details.promotions any promotions applied to this offer
     * @param {Object} options.merchandising merchandising information for this offer
     * @param {String} options.merchandising.code the merchandising code
     * @param {String} options.merchandising.family_code the merchandising family code
     * @param {Object} options.merchandising.copy the merchandising copy
     * @param {String} options.merchandising.copy.name the long name of this offer
     * @param {String} options.merchandising.copy.short_name the short name of this offer
     * @param {String} options.merchandising.copy.description the long description of this offer
     * @param {String} options.merchandising.copy.short_description the short description of this offer
     * @param {String} options.merchandising.copy.market_segment_name the market segment name
     * @param {String} options.merchandising.copy.market_segment_description the market segment description
     * @param {String} options.merchandising.copy.market_segment_short_description the short market segment description
     * @param {String} options.merchandising.assets.icons an object containing icon URLs
     * @param {Object} options.merchandising.fulfillable_items an array of objects containing code, assets.icons,
     *     copy.name, copy.enterprise_name, copy.description, and copy.short_description.
     * @param {Object} options.merchandising.links an object containing links relevant to this offer
     * @param {Array} options.merchandising.links.detailed_help_admin an array of objects with hrefs
     * @param {Array} options.merchandising.links.help_admin an array of objects with hrefs
     * @param {Array} options.merchandising.links.product_admin an array of objects with hrefs
     * @param {Array} options.merchandising.links.provisioned_user an array of objects with hrefs
     */
    return function offerFactory(options) {
      options = options || {};

      var offer = angular.copy(options);

      offer.isTeamOffer = offer.customer_segment === 'TEAM';
      offer.isEnterpriseOffer = offer.customer_segment === 'ENTERPRISE';

      // The response transformer filtered out offers without a short_name, so this path should exist on any
      // offer being constructed here.
      offer.shortName = offer.merchandising.copy.short_name;

      offer.isDeviceOffer = false;
      if (
        offer.hasOwnProperty('product_arrangement') &&
        offer.product_arrangement.hasOwnProperty('fulfillable_items')
      ) {
        _.forEach(offer.product_arrangement.fulfillable_items, function(item) {
          if (item.hasOwnProperty('delegation_type') && item.delegation_type === 'MACHINE') {
            offer.isDeviceOffer = true;
          }
        });
      }

      return offer;
    };
  });
})();
